import React from 'react';

const MyItem = () => {
    return (
        <div>
            <h1>MyItem</h1>
        </div>
    );
};

export default MyItem;